import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";

import VentasTable from "./VentasTable";
import VentasFilter from "../components/VentasFilter";
import ButtonsMenu from "../components/ButtonsMenu";
import NotesTable from "./NotesTable";
import DeleteSale from "./DeleteSale";
import CreateSale from "./CreateSale";
import UpdateSale from "./UpdateSale";
import Cookies from "js-cookie";
import { getUser } from "../../auth";
import socket from "../../socket";

const URL = process.env.REACT_APP_API_URL;

export default function Ventas() {
  const [sales, setSales] = useState([]);
  const [empresa, setEmpresa] = useState(null)
  const [filters, setFilters] = useState({
    dateFilter: "",
    totalRange: [0, 1000000],
    paymentMethod: ""
  });
  const [selectedAction, setSelectedAction] = useState(null); // "create", "update", "delete"
  const [selectedSales, setSelectedSales] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [productTypes, setProductTypes] = useState([]);

  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const user_rol = Cookies.get('user') ? JSON.parse(Cookies.get('user')).rol : null;

  const fetchSales = () => {
    const user = getUser();
    fetch(`${URL}/api/sales/`, {
      headers: {
        "X-Empresa-Id": user?.empresa_id,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error('Error al obtener ventas');
        return res.json();
      })
      .then((data) => setSales(data))
      .catch((error) => console.error(error));
  };

  const fetchAvaiableProducts = () => {
    const user = getUser();
    fetch(`${URL}/api/products/`, {
      headers: {
        "X-Empresa-Id": user?.empresa_id,
      },
    })
      .then((res) => res.json())
      .then((data) => setAllProducts(data))
      .catch((error) => console.error("Error fetching products:", error));
  };

  useEffect(() => {
    const user = getUser();
    fetch(`${URL}/api/products/types/`, {
      headers: {
        "X-Empresa-Id": user?.empresa_id,
      },
    })
      .then((res) => res.json())
      .then((data) => setProductTypes(data))
      .catch((err) => console.error("Error al cargar tipos:", err));
  }, []);

  useEffect(() => {
    fetchSales();
  }, []);

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const user = getUser();
        const response = await fetch(`${URL}/api/empresas/${user.empresa_id}`);
        if (response.ok) {
          const data = await response.json();
          setEmpresa(data);
        } else {
          console.error("Error al obtener la empresa");
        }
      } catch (error) {
        console.error("Error de red al obtener la empresa", error);
      }
    };

    fetchEmpresa();
  }, []);

  useEffect(() => {
    socket.on("stock_insuficiente", (data) => {
      const products = data.details
        .map(item => {
          return `• ${item.name}\nDisponible: ${item.available}\nRequerido: ${item.requested}`;
        })
        .join("\n\n");
      alert(`⚠️ No se pudo crear la venta:\n\n${products}`)
    });

    return () => {
      socket.off("stock_insuficiente");
    };
  }, [])

  const handleAction = (action) => {
    setSelectedAction((prev) => {
      if (prev === action) {
        if (action === "delete") {
          setIsDeleteMode(false);
          setSelectedSales([]);
        } else if (action === "update") {
          setIsUpdateMode(false);
          setSelectedSales([]);
        }
        return null;
      }
    
      // Cambia de acción
      if (action === "create") {
        fetchAvaiableProducts();
        setOpenCreateDialog(true);
        setIsUpdateMode(false);
        setIsDeleteMode(false);
        setSelectedSales([]);

      } else if (action === "update") {
        fetchAvaiableProducts();

        setIsUpdateMode(true);
        setIsDeleteMode(false);
        setSelectedSales([]);

      } else if (action === "delete") {
        setIsUpdateMode(false);
        setIsDeleteMode(true);
        setSelectedSales([]);
      }

    return action;
    });
  };

  const handleCloseCreateDialog = () => {
    setOpenCreateDialog(false);
    fetchSales();
    setSelectedAction(null);
  };

  const handleSelectAll = () => {
    if (selectedSales.length === sales.length) {
      setSelectedSales([]);
    } else {
      setSelectedSales(sales.map((sale) => sale.id));
    }
  };


  return(
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "90%",
        mt: 1,
      }}
      >
      <Box
        height={"12vh"}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          pr: 2,
        }}
      >
        <Box sx={{ width: "48vw", mt: 1}}>
          <VentasFilter onFilterChange={setFilters} />
        </Box>
        <ButtonsMenu
          selected={selectedAction}
          onAction={handleAction}
          rol={user_rol}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <VentasTable 
          headerData={['Id', 'Fecha', 'Detalle', 'Total', 'Método de pago', 'Está pagado']} 
          bodyData={sales} 
          setBodyData={setSales}
          onSelect={setSelectedSales}
          selectedRows={selectedSales}
          setSelectedRows={setSelectedSales}
          isDeleteMode={isDeleteMode}
          isUpdateMode={isUpdateMode}
          filters={filters}
        />

        {isUpdateMode && (
          <>
            <UpdateSale
              selectedSale={sales.find((sale) => sale.id === selectedSales[0])}
              allProducts={allProducts}
              productTypes={productTypes}
              onUpdate={() => {
                setSelectedSales([]);
                fetchSales();
              }}
              onClose={() => {
                setSelectedSales([]);
              }}
            />
          
          </>
        )}

        {!isUpdateMode && !isDeleteMode && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              mt: 2,
              pl: 4,
              color: "white",
              //borderRadius: 2,
              height: "66vh",
              width: "30vw"
            }}
          >
            <Box
              sx={{
                height: "100%",
                borderRadius: 2,
              }}
            >
              <NotesTable user_rol={user_rol} />
            </Box>
            
          </Box>
        )}

        {isDeleteMode && (
          <DeleteSale
            selectedSales={selectedSales}
            onDelete={() => {
              setSelectedSales([]);
              fetchSales();
            }}
          />
        )}

        {isDeleteMode && (
          <Button
            variant="contained"
            color="success"
            onClick={handleSelectAll}
            sx={{ 
              mt: 2,
              width: "16%",
              height: "7.6vh",
              marginLeft: 1.6,
              fontSize: {md: "12px", sm: "10px"},
            }}
          >
            Seleccionar todos
          </Button>
        )}

      </Box>

      <CreateSale
        open={openCreateDialog}
        onClose={handleCloseCreateDialog}
        allProducts={allProducts}
        productTypes={productTypes}
        empresa={empresa}
      />
    </Box>
  )
}
